import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token) => {

  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch (e) {
    return true;
  }
};

export const getToken = () => localStorage.getItem("token");
export const getRole = () => localStorage.getItem("role");
export const getUserInfo = () => localStorage.getItem("userInfo");

export const setToken = (token) => localStorage.setItem("token", token);
export const setRole = (role) => localStorage.setItem("role", role);
export const setUserInfo = (userInfo) => localStorage.setItem("userInfo", userInfo);

export const setCurrentCompanyId = (companyId) =>
  localStorage.setItem("companyId", companyId);
export const getCurrentCompanyId = () => localStorage.getItem("companyId");

export const clearToken = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("userInfo");
}
